export const DEPARTMENTTASKS = {
  accounts: [
    "Update Cash Book for Monthly Transactions on daily basis",
    "To Track the Company's Budget Forecast on a Daily Basis",
    "Track all Payments and Transactions Daily",
    "Ikeja Office Security Payment",
  ],

  "medical services": [
    "Match Patients to Doctors",
    "Ensure visits are carried out as at when due, reports are posted in a timely manner, prescribed drugs delivered and requested tests done and for those  Doctors whose visits cannot be held on appointment date, ensure they call the Elderlies involved and fix a convenient time.",
    "Ensure all Outstanding Visits are Carried Out",
    "Co-ordinate the Activities of Care Partners",
    "Manage Sponsor Needs",
  ],

  "elderly services": [
    "Call all Elderlies Visited during the week",
    "Visit and create a relationship with 1 church every week or provide 5 contact information every week",
  ],

  "client services": [
    "Attending to all sponsor requests that come up during the week",
    "Sending of Prescriptions to Sponsors",
    "Call Sponsors to Add Elderly during the week",
    "Followup on Outstanding payments during the week",
  ],

  admin: [
    "Manage the day to day operations of the GeroCare application and customer relationship management systems.",
    "Update payment records and assist colleagues with any necessary information they need to pull out from websites and applications",
    "Send daily visit report to Dr Ebi.",
  ],
};

export const INDIVIDUALTASKS = {
  "o.tobore@gerocare.org": [
    "Recruitment, orientation, and onboarding of new consultants/specialists. Match patients to consultants/specialists on request",
    "Manage all vendors, doctors, and specialist payments. Review and update vendor payment logs. Ensure prompt payment for on-demand and specialists' visits.",
    "Coordination and recruitment of care partners and management of corporate partnerships and relationships.",
    "Manage all sponsor clinical requests and enquiries. Manage sponsor relationships",
    "Supervise activities in the medical services department and oversee clinical needs of Gerocare projects.",
  ],
  "e.feghabo@gerocare.org": [
    "Ensure all medical requests are fulfilled in a timely manner by actively engaging partners covering Lagos and liasing with Dr. Tobore for those outside lagos. Monitor medical requests deliveries and update delivery statuses daily on CRM",
    "Coordinate activities of all Gerocare registered pharmacy, laboratory, and physiotherapy partners",
    "Validate visit reports/treatment plans and follow-up the medical care of special cases",
    "Manage all seniors' needs and concerns when called upon.",
    "Handle teleconsultation requests, MEDRA teleconsultations, and follow-up SDG beneficiaries",
  ],
  "o.olamide@gerocare.org": [
    "Recruitment, orientation, and onboarding of new doctors. Matching new patients to doctors and reassigning old patients to doctors when needed",
    "Ensure on-demand and first visits are done in a timely manner or contact the sponsor/elderly personally if the doctor has not contacted elderly by the third working day for new patients.",
    "Ensure all visits are carried out as at when due and reports submitted in a timely manner; for those doctors whose visits can not be carried out, to ensure that they contact the elderlies involved and fix a convenient time. Monitor corporate visits and resubscriptions.",
    "Send weekly reminders to all doctors who have visits during the week to call beneficiaries and schedule their appointments on the app and call doctors on the day of their visit. Ensure close visit tracking and daily updates on missed visits.",
    "Handle teleconsultation requests, MEDRA teleconsultations, and follow-up SDG beneficiaries. Manage all seniors’ clinical needs and requests.",
  ],
  "s.kebu@gerocare.org": [
    "Ensure all medical requests are fulfilled in a timely manner by actively engaging registered care partners and liasing with Dr. Tobore to engage/onboard new care partners when needed.",
    "Coordinate logistics/activities of all Gerocare registered pharmacy, laboratory, and physiotherapy partners. Ensure prompt communication of logistics schedules with the client services team.",
    "Manage medical requests' invoicing and deliveries and ensure prompt update of delivery statuses on CRM. Ensure daily updates of medical services investigation/activity logs on CRM.",
    "Mediate communications for physiotherapist/specialist appointment schedules between physiotherapy/medical services team and the client services team. Monitor physiotherapy visit schedules and timely report submission and uploads.",
    "Coordinate all sponsor WhatsApp group communications. Manage all general sponsor requests and enquiries.",
  ],
  "o.joy@gerocare.org": [
    "Call all elderlies visited",
    "Process all Caregiver Application",
    "Speak to Two People weekly",
    "Advertise Gerocare on my social media handles",
  ],
  "b.caleb@gerocare.org": [
    "Monitor and fix server errors",
    "Review and resolve incident reports tagged to the tech team",
    "Review error logs on sentry",
  ],

  "i.umoh@gerocare.org": [
    "Planning & Managing of brokers Consolidating with materials/followup",
    "Create/implement strategies to reach out to potential sponsors, brokers, associations, corporate bodies, churches and estates",
    "Oversee and Managing B2B, B2C, and B2G Businesses",
    "Coordinating with other departments to improve interaction with clients and customers",
    "Working with my team to brainstorm new and innovative growth strategies",
    "Evaluating important metrics that affect our offline and online businesses",
    "identifying latest trends affecting our offline and online businesses",
    "Coordinating with other departments to improve interaction with clients and customers",
  ],
  "e.john@gerocare.org": [
    "Communicate with onboarding sponsors and follow up with sponsors who are due for follow up",
    "Distribute copy of all initiatives, including marketing, sales, and internal communications",
    "Post on the Seniors Support Group and keep it active",
    "Post on the Twitter page and respond to messages",
    "Monitor all company social media platforms and provide reports on activities carried out",
    "Give reports on products and services engaged with",
  ],
  "d.paul@gerocare.org": [
    "To carry out research on caregiver recruitment agencies nationwide",
    "Liase with Joy to work through the caregiver activity spreadsheet",
  ],
};
